export default {
  page: {
    'SP : Home': {},
    'SP : Lead Board': {},
    'SP : Message': {},
    'Business Center - Agreement Flow - Thank You': {},
  },
  elements: {
    'Item Clicked': {},
    'SFDC Lead Created': {},
    'Business Created': {},
    'Advertising Request Sent': {},
  },
};



// WEBPACK FOOTER //
// ./src/app/common/targetMetrics.js